import styled from "styled-components";
import { device } from "../../../style/styled-components/helpers/device";
// 진행 단계 하나: 아이콘 원 + 제목 + 세부 항목. 넓은 화면에서는 아이콘끼리 점선으로 잇는다(noLine이면 생략)
const ProcessElement = ({ icon, title, details, noLine, smallTitle }) => {
  return (
    <Div $line={!noLine && !!icon}>
      {icon && (
        <div className="icon">
          <img src={icon} alt="" />
        </div>
      )}
      <div className="text">
        <TitleSpan smallTitle={smallTitle}>{title}</TitleSpan>
        <List>
          {details?.map((x) => {
            return <li key={x}>{x}</li>;
          })}
        </List>
      </div>
    </Div>
  );
};
export default ProcessElement;
const Div = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 1.25rem;
  @media ${device.laptop} {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0 0.75rem;
    &:before {
      content: "";
      display: ${({ $line }) => ($line ? "block" : "none")};
      position: absolute;
      top: 3.5rem;
      left: 0;
      right: 0;
      border-top: 2px dashed ${({ theme }) => theme.colors.light};
    }
    &:first-child:before {
      left: 50%;
    }
    &:last-child:before {
      right: 50%;
    }
  }
  & > .icon {
    position: relative;
    z-index: 1;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 5.5rem;
    height: 5.5rem;
    border-radius: 50%;
    background-color: white;
    border: 1px solid ${({ theme }) => theme.colors.line};
    box-shadow: ${({ theme }) => theme.shadow.sm};
    @media ${device.laptop} {
      width: 7rem;
      height: 7rem;
    }
    & > img {
      width: 55%;
    }
  }
  & > .text {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
    @media ${device.laptop} {
      align-items: center;
    }
  }
`;
const TitleSpan = styled.span`
  font-size: ${(props) => (props.smallTitle ? "1.15rem" : "1.35rem")};
  font-weight: 800;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.colors.dark};
`;
const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.95rem;
  color: ${({ theme }) => theme.colors.foreground.dimmed};
  & > li:before {
    content: "·";
    margin-right: 0.35rem;
    color: ${({ theme }) => theme.colors.accent};
    font-weight: 800;
  }
`;
